<template>
  <section class="money-card">
    <div class="image-wrapper">
      <img :src="image" alt="" />
    </div>
    <div class="amount-wrapper">
      <div class="name">{{ name }}</div>
      <div class="amount">$ {{ amount | formatNumber(2) }}</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MoneyCard',
  props: {
    image: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: 0
    },
    name: {
      typeof: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.money-card {
  display: flex;
  align-items: center;

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    width: 100%;
    justify-content: space-around;
  }
}
.amount-wrapper {
  display: flex;
  flex-direction: column;
  margin-left: 32px;

  & .name {
    font-size: 21px;
    font-family: NotoSansCJKsc-Medium;
    margin-bottom: 12px;
  }

  & .amount {
    font-size: 32px;
    font-weight: 900;
    color: $HIGHLIGHT_COLOR;
    font-family: Oblivian;
  }
}
</style>
